module.exports = __webpack_public_path__ + "assets/img/contact.78787174.svg";